import React from "react";
import { useRecoilValue } from "recoil";
import { isMobileMatcheState } from "../../../../atoms/atom";
import { IPageHeaderShowProps } from "../../../../views/Main";
import PageCategory from "./pageMenu/PageCategory";
import PageGameList from "./pageMenu/PageGameList";
import PageSearch from "./pageMenu/PageSearch";

function PageLeft({ len }: IPageHeaderShowProps) {
  const isMobile = useRecoilValue(isMobileMatcheState);
  return (
    <>
      <div className={`page-left ${len}`}>
        {!isMobile ? (
          <>
            <PageSearch />
            <PageCategory />
            <PageGameList />
          </>
        ) : null}
      </div>
    </>
  );
}

export default PageLeft;
